import React, { InputHTMLAttributes, useState } from 'react';
import { TextInput, TextInputProps } from '@workday/canvas-kit-react/text-input';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { invisibleIcon, visibleIcon } from '@workday/canvas-system-icons-web';
import styles from './password-input.module.scss';
import classNames from 'classnames';

type PasswordTextInputProps = TextInputProps &
    Pick<
        InputHTMLAttributes<HTMLInputElement>,
        | 'autoFocus'
        | 'autoComplete'
        | 'id'
        | 'className'
        | 'disabled'
        | 'onChange'
        | 'onBlur'
        | 'onFocus'
        | 'placeholder'
    > & {
        showPasswordText: string;
        showPasswordtestId?: string;
    };

export const PasswordTextInput = React.forwardRef<HTMLInputElement, PasswordTextInputProps>((props, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className={classNames(styles.container, props.className, { [styles.grow]: props.grow })}>
            <TextInput {...props} ref={ref} type={showPassword ? 'text' : 'password'} />
            <TertiaryButton
                aria-label={props.showPasswordText}
                icon={showPassword ? invisibleIcon : visibleIcon}
                size='small'
                className={styles.iconButton}
                data-testid={props.showPasswordtestId}
                role='switch'
                type='button'
                disabled={props.disabled}
                aria-checked={showPassword}
                onClick={() => setShowPassword(!showPassword)}
            />
        </div>
    );
});
